import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.scss']
})
export class BookingsComponent implements OnInit {
  private modalRef: any;
  bookings: any;
  telegramBookings: any[]
  order_detail: any;
  imgUrl = environment.ImageUrl;
  baseUrl = environment.baseUrlAdmin

  telegramTablePage: number = 1;
  telegramFetchSinceDate?: Date | null = null;
  maxTelegramPageIndex: number = 2;

  public increasePageIndex() {
    if (this.telegramTablePage + 1 > this.maxTelegramPageIndex) {
      return;
    }
    this.telegramTablePage++;
    console.log(this.telegramFetchSinceDate)
    this.getTelegramBookings()
  }
  public decreasePageIndex() {
    if (this.telegramTablePage - 1 <= 0) {
      return;
    }
    this.telegramTablePage--;
    this.getTelegramBookings()
  }
  public setTelegramTablePage(val: number) {
    if (val <= 0) {
      throw new Error("Error invalid page index: " + val);
    }
    this.telegramTablePage = val;
  }
  public setTelegramFetchSinceDate(val: Date) {
    this.telegramFetchSinceDate = val;
  }
  selMenu: string = 'bookings'

  public selectMenu(menu: string) {
    this.selMenu = menu;
  }

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private modalService: NgbModal,
    private http: HttpClient,

  ) { }

  ngOnInit(): void {
    this.getBookings();
    this.getTelegramBookings();
  }

  getTelegramBookings() {
    this.http.get(`${this.baseUrl}getTelegramBookings?offset=${this.telegramTablePage}&since=${this.telegramFetchSinceDate}
        `).subscribe((e: any) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);

      }
      else if (e.status == 401 || e.status == 401) {
        this.local.logout();
        this.router.navigate(['/']);
      } else {
        console.log("telegram bookings", e)
        this.telegramBookings = e.orders;
        this.maxTelegramPageIndex = e.pageCount


      }
    });
  }
  getBookings() {
    this.auth.getBookings().subscribe((response: any) => {
      this.bookings = response.body;

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
      if (e.error.status == 401 || e.status == 401) {
        this.local.logout();
        this.router.navigate(['/']);
      }
    });
  }

  // change_order_status(orderId, status) {
  //   console.log(orderId)
  //   console.log(status)

  //   const formData = new FormData();
  //   formData.append("orderId", orderId);
  //   formData.append("status", status);
  //   this.auth.change_order_status(formData).subscribe((response: any) => {
  //     if(response.body.status == 1) {
  //       this.toastr.success(response.message);
  //     } else if (response.body.status == 2) {
  //       this.toastr.warning(response.message);
  //     } else if (response.body.status == 3) {
  //       this.toastr.warning(response.message);
  //     } else {
  //       this.toastr.info(response.message);
  //     }
  //    }, (e) => {
  //      if (e.status == 400) {
  //        this.toastr.error(e.error.message);
  //      }
  //      if (e.error.status == 401 || e.status == 401) {
  //        this.local.logout();
  //        this.router.navigate(['/']);
  //      }
  //    });
  // }

  // order_details(modal, orderId) {
  //   this.order_detail = this.bookings.find(data => data.id == orderId);
  //   this.modalService.dismissAll();
  //   this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'modal_dialog_pad' });
  // }

}
